export const presentYear = () => {
  const today = new Date();
  const todayYear = today.getFullYear();

  return todayYear;
};



// WEBPACK FOOTER //
// ./constants/getPresentYear.ts